import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { RadioButtonGroup, RadioButton } from 'material-ui/RadioButton';
import { AVAILABLE_TO } from '../../../shared/utils/constants';

export default function AvailableToSelector({ input, t, ...rest }) {
  return (
    <MuiThemeProvider>
      <RadioButtonGroup
        {...input}
        {...rest}
        valueSelected={input.value}
        onChange={(event, value) => input.onChange(value)}
        style={{ display: 'flex', width: '100%' }}
      >
        <RadioButton
          iconStyle={{ fill: '#646777' }}
          labelStyle={{ color: '#646777' }}
          value={AVAILABLE_TO.ONLY_RESPONSIBLES}
          label={t(
            `mnt_communication_channel.availableTo-${AVAILABLE_TO.ONLY_RESPONSIBLES}`
          )}
        />
        <RadioButton
          iconStyle={{ fill: '#646777' }}
          labelStyle={{ color: '#646777' }}
          value={AVAILABLE_TO.ONLY_STUDENTS}
          label={t(
            `mnt_communication_channel.availableTo-${AVAILABLE_TO.ONLY_STUDENTS}`
          )}
        />
        <RadioButton
          iconStyle={{ fill: '#646777' }}
          labelStyle={{ color: '#646777' }}
          value={AVAILABLE_TO.RESPONSIBLES_AND_STUDENTS}
          label={t(
            `mnt_communication_channel.availableTo-${AVAILABLE_TO.RESPONSIBLES_AND_STUDENTS}`
          )}
        />
      </RadioButtonGroup>
    </MuiThemeProvider>
  );
}

AvailableToSelector.propTypes = {
  input: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
};
